/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { CONNEX_UDM_DELIVERIES_PATH_TOKENS } from './connexUdmDeliveriesPathTokens';
import { isQrLineItemDotPathToken } from './qrLineItemPathTokens';

const connexValidKeys = new Set(CONNEX_UDM_DELIVERIES_PATH_TOKENS);

export const referencedKeys = template => {
  const found = [];
  const rxp = /{([^}]+)}/g;
  let curMatch;

  while ((curMatch = rxp.exec(template))) {
    found.push(curMatch[1]);
  }

  return found;
};

export const getInvalidQrTemplateReferences = (templateString, emptyContext) => {
  const validKeys = new Set([...Object.keys(emptyContext ?? {}), ...connexValidKeys]);

  return referencedKeys(templateString).filter(token => !validKeys.has(token) && !isQrLineItemDotPathToken(token));
};
